import styled from '@emotion/styled'
import Link from 'next/link'

import { ADD_NEW_RULE_QUERY_ID } from './helpers'
import Button from 'components/Button'
import { FeatureExplanation } from 'components/FeaturesList'
import { PlusIcon } from 'components/icons'

const TopSection = styled.div`
	flex-shrink: 0;
	max-width: 560px;
	margin-bottom: ${({ theme }) => theme.spaces.space6};
`

const BaseLink = styled(Link)`
	text-decoration: none;
`

const AddRuleButton = styled(Button)`
	padding: ${({ theme }) => theme.spaces.space3};
	flex-direction: row-reverse;
	padding-right: ${({ theme }) => theme.spaces.space5};
	${({ theme }) => theme.typography.captionMedium};
`

type Props = {
	allowToAddNewRule: boolean
}

function RuleFormHeader({ allowToAddNewRule }: Props) {
	return (
		<TopSection>
			<FeatureExplanation>
				Rules allow you to display specific widget configurations (templates) to your customers on the given website.
				Higher-listed rules have priority.
			</FeatureExplanation>
			{allowToAddNewRule && (
				<BaseLink href={`/advanced-settings/rules/${ADD_NEW_RULE_QUERY_ID}`}>
					<AddRuleButton kind="primary" type="button" icon={<PlusIcon />} disableHover>
						Add new rule
					</AddRuleButton>
				</BaseLink>
			)}
		</TopSection>
	)
}

export default RuleFormHeader
